import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Mousewheel } from 'swiper/modules';

import { Slider } from '@atlas/components';

import { useIsRtl } from 'hooks/useIsRtl';

import InfoGame from './InfoGame';

const GAME_SIZES = {
  LARGE: 'L',
  MEDIUM: 'M',
  SMALL: 'S',
};

const responsiveGamesInRowBySize = {
  m: {
    [GAME_SIZES.LARGE]: 3,
    [GAME_SIZES.MEDIUM]: 4,
    [GAME_SIZES.SMALL]: 6,
  },
  //eslint-disable-next-line
  l: {
    [GAME_SIZES.LARGE]: 4,
    [GAME_SIZES.MEDIUM]: 5,
    [GAME_SIZES.SMALL]: 7,
  },
  xl: {
    [GAME_SIZES.LARGE]: 5,
    [GAME_SIZES.MEDIUM]: 6,
    [GAME_SIZES.SMALL]: 8,
  },
  xxl: {
    [GAME_SIZES.LARGE]: 6,
    [GAME_SIZES.MEDIUM]: 7,
    [GAME_SIZES.SMALL]: 9,
  },
};

export const InfoGamesSlider = memo(function InfoGamesSlider({
  games,
  isFavorites,
  setSwiper,
  sliderSettings: propSliderSettings,
}) {
  const isRtl = useIsRtl();
  const { rows, size } = propSliderSettings;

  const sliderConfig = useMemo(
    () => ({
      dir: isRtl ? 'rtl' : 'ltr',
      grid: {
        fill: 'row',
        rows: rows,
      },
    }),
    [isRtl, rows],
  );

  const responsiveSliderSettings = useMemo(() => {
    return {
      1: {
        grid: {
          rows: rows,
        },
        slidesPerView: responsiveGamesInRowBySize.m[size],
      },
      1211: {
        grid: {
          rows: rows,
        },
        slidesPerView: responsiveGamesInRowBySize.l[size],
      },
      1459: {
        grid: {
          rows: rows,
        },
        slidesPerView: responsiveGamesInRowBySize.xl[size],
      },
      1641: {
        grid: {
          rows: rows,
        },
        slidesPerView: responsiveGamesInRowBySize.xxl[size],
      },
    };
  }, [size, rows]);

  return (
    games.length && (
      <Slider
        autoplay={false}
        breakpoints={responsiveSliderSettings}
        breakpointsBase="container"
        className="casino__slider-games"
        dir={sliderConfig.dir}
        grid={sliderConfig.grid}
        loop={false}
        modules={[Mousewheel]}
        mousewheel={{ forceToAxis: true }}
        onBeforeInit={setSwiper}
        slidesPerView={responsiveGamesInRowBySize.xxl[propSliderSettings.size]}
        spaceBetween={8}
      >
        {games.map(game => (
          <Slider.Slide key={game.id ?? game.gameRelationId}>
            <InfoGame
              game={game}
              gameItemClass="game"
              isFavorites={isFavorites}
              responsiveSliderSettings={responsiveSliderSettings}
              size={propSliderSettings.size}
            />
          </Slider.Slide>
        ))}
      </Slider>
    )
  );
});

InfoGamesSlider.propTypes = {
  games: PropTypes.array.isRequired,
  isFavorites: PropTypes.bool,
  setSwiper: PropTypes.func.isRequired,
  sliderSettings: PropTypes.shape({
    rows: PropTypes.number,
    size: PropTypes.string,
  }),
};
